import React, { useEffect, useState } from 'react'
import queryString from 'query-string';
import Pc_TopTitle from './Pc_TopTitle';
import { Container } from 'react-bootstrap';
import { instance,comma } from './common';
import ContractPopup from './components/ReserveDetail/ContractPopup';

function totalPrice(data, discount) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
        if (v.c_option) {
            JSON.parse(v.c_option).forEach(function (items) {
                price += Number(items.price);
            });
        }
    });
    price = price - discount;
    return comma(price);
}


function sendPrice(data, discount) {
    let price = 0;
    data.forEach(function (v) {
        price += Number(v.s_member_price);
        if (v.c_option) {
            JSON.parse(v.c_option).forEach(function (items) {
                price += Number(items.price);
            });
        }
    });
    price = price - discount;
    return price;
}

function SigongId({ si_id, si_data, setSiData }) {
    let obj = { si_id: si_id }
    useEffect(() => {

        const fetchData = async () => {
            instance.post('/sigong/id', obj).then(function (res) {

                setSiData(res.data[0]);
            });

        };

        fetchData();

    }, []);


    const { si_name, si_address } = si_data;

    return (
        <>
            <h3 className="font-weight-bold mb-3" id="si_name">{si_name}</h3>
            <span id="si_address">{si_address}</span>
        </>
    )
}


function ServiceId({ data, u_type, date, discount }) {
 
    return (
        <>
            {
                data.length !==0 &&
                data.map(v => <div className="row p-0 mt-2 mb-5 thisSinchungTop" key={v.s_id}>
                    <div className="col-2 p-0 py-4" id="s_img">
                        <div className="r_r_bg_pc" style={{ backgroundImage: 'url(' + v.s_img + ')' }}></div>
                    </div>
                    <div className="col-8 pr-0 py-4">
                        <div className="font-weight-bold r_title mb-2" id="s_name">{v.s_name}</div>
                        <div className="r_subtext_pc" id="s_content"></div>
                        <h5 data-id={v.s_id} className="font-weight-bold text-lightgray" style={{ textDecoration: 'line-through', lineHeight: '0' }}>소비자가 : {comma(v.s_price)}</h5>
                        <div className=" font-weight-bold r_title" id="s_price">
                            특별할인가 : {
                                u_type == '일반고객'
                                    ? comma(v.s_price)
                                    : comma(v.s_member_price)
                            }원</div>
                        {
                            v.c_option &&
                            <ul className="">
                                {
                                    JSON.parse(v.c_option).map((options, i) =>
                                        <li className="d-block font-weight-bold" key={i}> + {options.name} : {comma(options.price)}  </li>)
                                }
                            </ul>
                        }
                    </div>
                    <div className="col-2 py-4 text-center border-left">
                            <div className=" font-weight-bold r_title" id="s_price">
                            {
                                u_type == '일반고객'
                                    ? comma(v.s_price)
                                    : comma(v.s_member_price)
                            }원</div>
                            {
                            v.c_option &&
                            <ul className="">
                                {
                                    JSON.parse(v.c_option).map((options, i) =>
                                        <li className="d-block font-weight-bold" key={i}> + {options.name} : {comma(options.price)}  </li>)
                                }
                            </ul>
                        }

                    </div>
                </div>)
            }
            <div className="r_b_border mb-4">
                <h3 className="font-weight-bold mb-3">예약정보</h3>
            </div>
            <div className="row r_mb_down p-0">
                <div className="col-3 pl-0">
                    <span className="font-weight-bold d-block r_s_size">예약일</span>
                    <span className="d-none" id="s_tel"></span>
                </div>
                <div className="col-9">
                    <div id="si_date" className="text-right">{date}</div>
                </div>
            </div>
            <div className="row mb-4 p-0">
                <h3 className="font-weight-bold mb-3">금액정보</h3>
            </div>
            <div className="row p-0">
                <div className="col-4 pl-0">
                    <span className="font-weight-bold d-block r_s_size">서비스명</span>
                </div>
                <div className="col-8">
                    {
                        data.length !==0 &&
                        data.map(v =>
                            <div className="mb-3 text-right"><span className="font-weight-bold" id="service_price">{v.s_cate}</span></div>
                        )
                    }
                    
                </div>
            </div>

            {
                discount &&
                <>
                    <hr className="r_mg_top_none" />
                    <div className="row p-0">
                        <div className="col-4 pl-0">
                            <span className="font-weight-bold d-block r_s_size">할인금액</span>
                        </div>
                        <div className="col-8">
                            <div className="mb-3 text-right"><span className="font-weight-bold text-danger"> - {comma(discount)}원</span></div>
                        </div>
                    </div>
                </>
            }
            <hr className="r_mg_top_none" />
            <div className="row r_mbdown p-0">
                <div className="col-3 pl-0">
                    <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
                </div>
                <div className="col-9">
                    <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice">{data.length !==0 && totalPrice(data, discount)}원</div>
                </div>

            </div>
        </>

    )
}



function Pc_Reserve_detail({ history, location }) {
    const session = JSON.parse(window.sessionStorage.result);
    const { u_type, u_id } = session;

    const query = queryString.parse(location.search);

    let r_id = query.r_id;
    let si_id = query.si_id;
    let date = query.date;
    let status = query.status;
    let fail = query.fail;

    const [data, setData] = useState([]);
    const [si_data, setSiData] = useState([]);
    const [isTitle, setTitle] = useState('신청내역 확인');
    const [r_status, setStatus] = useState('');
    const [contract_num, setNum] = useState('');
    const [discount, setDiscount] = useState('');
    const [promotionText, setText] = useState('계약번호');
    const [modal, setModal] = useState(false);

    // s_id useState
    const [isS_id, setIsS_id] = useState([]);

    let obj = { r_id: r_id }
    useEffect(() => {

        // if (status == '16') {
        //     alert('결제가 실패되었습니다.');
        // }
        if (status == '0000') {
            setTitle('신청이 완료되었습니다');
        }
        if(fail == '0'){
            setTitle('결제가 실패되었습니다.');
        }

        const fetchData = async () => {
            instance.post('/reserve/r_id', obj).then(function (res) {
                // console.log('pc 초반 로드 : ', res, res.data[0].contract_num);

                if(JSON.parse(res.data[0].s_id)[0].s_cate === '썬가드하이퍼이벤트'){
                    setText('차대번호');
                 }
                setIsS_id(JSON.parse(res.data[0].s_id));
                setData(res.data[0]);
                setStatus(res.data[0].r_status);
                setNum(res.data[0].contract_num);
                if (res.data[0].contract_num) {
                    instance.post('/contract/num', { contract_num: res.data[0].contract_num }).then(function (res) {

                        setDiscount(res.data[0].co_discount)
                    });
                }

                if (status == '00') {
                    let obj = {
                        r_status: '결제완료',
                        r_gubun: '온라인'
                    }
                    let updateObj = {
                        obj: obj,
                        whereField: 'r_id',
                        whereValue: r_id,
                    }
                    const fetchData = async () => {
                        instance.post('/reserve/update', updateObj).then(function (res) {
                            console.log('업데이트 성공');
                            setStatus('결제완료');
                        });

                    };

                    fetchData();
                }
            });

        };

        fetchData();

    }, []);



    const onClick = () => {
        history.push('/repReserve?si_id=' + si_id);
    }

    const goBack = () => {
        history.goBack();
    }


    const MobilePay = () => {
        let str = '';
        let price = '';
        let name = '';
        let nameStr = '';
        let o_id = 'ABYS_OR_NUM' + contract_num;
        if (data.s_id) {
            str = JSON.parse(data.s_id);
            price = sendPrice(str, discount);
            if (str.length > 1) {
                nameStr = '외 ' + str.length + ' 개'
            }

            name = str[0].s_name + nameStr;

        }

        console.log('price : ', price)
        window.location.replace('https://abys-service.co.kr/inisys/new-pcpay.php?r_id=' + r_id + '&si_id=' + si_id + '&date=' + date + '&price=' + price + '&name=' + name + '&o_id=' + o_id);
    }

    const toggle = () => setModal(!modal);

    return (
        <>
            {modal && <ContractPopup toggle={toggle} modal={modal} r_id={r_id} date={date} si_id={si_id} />}
            <Container className="mb-5">
                <div className="c_pad">
                    <Pc_TopTitle title={isTitle} />
                    <SigongId si_id={si_id} setSiData={setSiData} si_data={si_data} />
                    <div className="thisCartTitleBox2"></div>
                    <div className="row p-0 py-3 ">
                        <div className="col-10 text-center sangTitleText">상품정보</div>
                        <div className="col-2 p-0 text-center sangTitleText">
                            <span className="sangTitleText">금액</span>
                        </div>
                    </div>
                    <ServiceId
                        data={isS_id}
                        u_type={u_type}
                        date={date}
                        discount={discount}
                    />
                    <div className="w-100 text-center">
                    {
                        r_status == '예약완료' &&
                        <div className="row mb-2 p-0">

                            <div className="col-4 mx-auto text-center pl-0 pr-0">
                                {
                                    contract_num
                                        ?
                                        <span className="btn btn-secondary r_btnsize">프로모션 인증완료</span>
                                        :
                                        promotionText === '계약번호' && <span className="btn r_btnsize" style={{ backgroundColor:"#2F79D9", color:"white" }} onClick={toggle}>프로모션 인증(계약번호 인증)</span>
                                }

                            </div>
                        </div>
                    }
                    {
                        r_status == '예약완료'
                            ?
                            <div className="row mb-5 p-0">
                                {
                                    contract_num &&
                                    <>
                                        <div className="col-4 mx-auto text-center pl-0 pr-0">
                                            {promotionText === '계약번호' && <span className="btn btn-primary r_btnsize" onClick={MobilePay}>지금 결제하기</span>}
                                            
                                        </div>
                                        <div className="col-4 mx-auto text-center pl-0 pr-0 d-none">
                                            <span className="btn btn-outline-secondary r_btnsize" onClick={onClick}>현장 결제</span>
                                        </div>
                                    </>
                                }
                            </div>
                            :
                            <div className="row mb-5 p-0">
                                <div className="col-4 mx-auto text-center pl-0 pr-0">
                                    <span className="btn btn-primary r_btnsize" onClick={() => history.push('/myReserve')}>예약 내역</span>
                                </div>
                            </div>
                    }
                    </div>
                    <div className="row mt-2 p-0">
                        <span className="col-12 btn btn-primary r_btnsize" onClick={() => window.location.replace('/')}>홈 으로</span>
                    </div>
                </div>
            </Container>

        </>

    )
}

export default Pc_Reserve_detail